import template from './tsz-progress-bar.html';
import './tsz-progress-bar.styl';

export default {
  template,
  bindings: {
    max: '<',
    value: '<',
  },
};



// WEBPACK FOOTER //
// ./src/components/tsz-progress-bar/tsz-progress-bar.js